import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import ErrorBoundary from './components/ErrorBoundary.tsx';
import App from './App.tsx';
import './index.css';

/** Eski bozuk service worker kayıtlarını kaldır (beyaz sayfa / Star is not defined vb.) */
async function removeLegacyServiceWorkers() {
  if (!('serviceWorker' in navigator)) return;
  const regs = await navigator.serviceWorker.getRegistrations();
  await Promise.all(regs.map((r) => r.unregister()));
  if ('caches' in window) {
    const names = await caches.keys();
    await Promise.all(names.map((n) => caches.delete(n)));
  }
}

const rootEl = document.getElementById('root');

function formatBootError(err: unknown): string {
  const message = String((err as Error)?.message || err || 'Bilinmeyen hata');
  if (/unexpected token|invalid token/i.test(message)) {
    return (
      'JavaScript dosyası yüklenemedi veya bozuk (genelde eski önbellek / eksik dist yüklemesi). ' +
      'Tarayıcı önbelleğini temizleyin, gizli pencerede deneyin; sunucuda dist/assets içindeki tüm .js dosyalarının yüklü olduğundan emin olun.'
    );
  }
  if (/failed to fetch dynamically imported module|importing a module script failed/i.test(message)) {
    return (
      'Uygulama modülü indirilemedi. dist klasörünün tamamını (index.html + assets/*.js) yeniden yükleyin ve önbelleği temizleyin.'
    );
  }
  return message;
}

function showBootError(message: string) {
  if (!rootEl) return;
  rootEl.innerHTML = `
    <div style="font-family:system-ui,sans-serif;max-width:32rem;margin:3rem auto;padding:1.5rem;text-align:center">
      <h1 style="font-size:1.25rem;margin-bottom:0.75rem">Site yüklenemedi</h1>
      <p style="color:#555;font-size:0.9rem;line-height:1.5;margin-bottom:1rem">${message}</p>
      <p style="color:#888;font-size:0.8rem">Geliştirme: proje kökünde <code>.env</code> dosyasında <code>VITE_SUPABASE_URL</code> ve <code>VITE_SUPABASE_ANON_KEY</code> tanımlı olmalı. Yayın: <code>npm run build</code> bu dosyayla çalıştırılmalı; <code>dist</code> klasörünün tamamı yüklenmeli.</p>
    </div>`;
}

async function bootstrap() {
  await removeLegacyServiceWorkers();

  if (!rootEl) {
    document.body.innerHTML =
      '<p style="font-family:sans-serif;padding:2rem">Kök element (#root) bulunamadı.</p>';
    return;
  }

  if (!import.meta.env.VITE_SUPABASE_URL?.trim() || !import.meta.env.VITE_SUPABASE_ANON_KEY?.trim()) {
    showBootError(
      'Supabase yapılandırması eksik. Build sırasında ortam değişkenleri bundle’a gömülmemiş olabilir.',
    );
    return;
  }

  createRoot(rootEl).render(
    <StrictMode>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </StrictMode>,
  );
}

bootstrap().catch((err) => {
  console.error(err);
  showBootError(formatBootError(err));
});
